import React, { useState, useEffect } from 'react';
import {
    Box,
    List,
    Breadcrumbs,
    Link,
    Typography,
    Paper,
    CircularProgress,
    Alert,
} from '@mui/material';
import { Home, Folder } from '@mui/icons-material';
import FileItem from './FileItem';
import { fileExplorerAPI } from '../services/api';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Grid from '@mui/material/Grid';

const FileExplorer = ({ onVideoSelect }) => {
    const [currentPath, setCurrentPath] = useState('');
    const [files, setFiles] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        loadFiles(currentPath);
    }, [currentPath]);

    const loadFiles = async (path) => {
        setLoading(true);
        setError('');
        try {
            const response = await fileExplorerAPI.getFiles(path);
            setFiles(response.data);
        } catch (err) {
            setError('Failed to load files');
            console.error('Error loading files:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleFileSelect = (file) => {
        setSelectedFile(file);
        if (!file.directory) {
            onVideoSelect(file);
        }
    };

    const handleFileDoubleClick = (file) => {
        if (file.directory) {
            setCurrentPath(file.path);
        }
    };

    const handleBreadcrumbClick = (path) => {
        setCurrentPath(path);
    };

    const generateBreadcrumbs = () => {
        if (!currentPath) return [];

        const pathParts = currentPath.split('\\');
        const breadcrumbs = [];
        let accumulatedPath = '';

        breadcrumbs.push({
            name: 'Home',
            path: '',
            icon: <Home fontSize="small" />
        });

        for (let i = 0; i < pathParts.length; i++) {
            if (pathParts[i]) {
                accumulatedPath += (accumulatedPath ? '\\' : '') + pathParts[i];
                breadcrumbs.push({
                    name: pathParts[i],
                    path: accumulatedPath,
                    icon: <Folder fontSize="small" />
                });
            }
        }

        return breadcrumbs;
    };

    return (
        <Paper elevation={2} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    {generateBreadcrumbs().map((breadcrumb, index) => (
                        <Link
                            key={index}
                            color={index === generateBreadcrumbs().length - 1 ? 'text.primary' : 'inherit'}
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                handleBreadcrumbClick(breadcrumb.path);
                            }}
                            underline='none'
                            sx={{ display: 'flex', alignItems: 'center' }}
                        >
                            {breadcrumb.icon}
                            {breadcrumb.name}
                        </Link>
                    ))}
                </Breadcrumbs>
            </Box>

            <Box sx={{ flex: 1, overflow: 'auto' }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                        <CircularProgress />
                    </Box>
                ) : error ? (
                    <Alert severity="error" sx={{ m: 2 }}>{error}</Alert>
                ) : (
                    files.length < 1 ? (
                        <Paper
                            elevation={2}
                            sx={{
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'grey.100'
                            }}
                        >
                            <Typography variant="h6" color="textSecondary">
                                No Files.
                            </Typography>
                        </Paper>
                    ) : (
                        // <List>
                        <Grid container spacing={2}>
                            {files.map((file) => (
                                <FileItem
                                    key={file.path}
                                    item={file}
                                    isSelected={selectedFile && selectedFile.path === file.path}
                                    onSelect={handleFileSelect}
                                    onDoubleClick={handleFileDoubleClick}
                                />
                            ))}
                         {/* </List> */}
                        </Grid>
                    )
                )}
            </Box>
        </Paper>
    );
};

export default FileExplorer;